/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { PublicUserPermissionAssignmentDto } from './PublicUserPermissionAssignmentDto';

export type PublicUserCreateDto = {
    /**
     * Authorized authentication type of the user
     */
    authTypes?: Array<'SAML2' | 'LOGIN_PASSWORD'>;
    /**
     * Email of the user
     */
    email: string;
    /**
     * Name of the user
     */
    name: string;
    /**
     * Domain access permissions of the user
     */
    permissions?: Array<PublicUserPermissionAssignmentDto>;
    /**
     * System role of the user
     */
    role: PublicUserCreateDto.role;
};

export namespace PublicUserCreateDto {

    /**
     * System role of the user
     */
    export enum role {
        ADMIN = 'ADMIN',
        EDITOR = 'EDITOR',
        VIEWER = 'VIEWER',
    }


}
